export const KEY_AUDIO_VOLUME = "kAudioVolume";

export function saveAudioVolume(level) {
    if (typeof(level) !== 'number' || !localStorage) return;

    try {
        localStorage.setItem(KEY_AUDIO_VOLUME, level);
    } catch (e) {
        // do nothing;
    }
}

export function loadAudioVolume() {
    let volume = 1.0;
    if (!localStorage) return volume;

    try {
        const value = localStorage.getItem(KEY_AUDIO_VOLUME);
        if (value !== null) volume = parseFloat(value);
        return typeof(volume) === 'number' ? Math.max(0, Math.min(volume, 1.0)) : 1.0;
    } catch (e) {
        // do nothing;
    }
    return 1.0;
}
